<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>棚割最大パターン：{{ tanaNum }}本</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    tanaNum: {
      type: Number,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
